<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col cols="12" class="pa-0">
            <v-card class="flex pa-0 round-card background-2">
                <v-card-title class="pa-3">
                    <div>
                        <p class="pl-2 pl-xl-3">Attributi Prodotto</p>
                    </div>              
                    <div>
					    <p v-if="entityTitle" class="entity-title">&nbsp;&nbsp;{{ entityTitle }}</p>
				    </div>
                </v-card-title>
                <v-divider></v-divider>
                <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}">
                    <v-row class="ma-0">
                        <v-col cols="12" sm="12" md="8" lg="8" :class="{'pr-4': $vuetify.breakpoint.mdAndUp}">
                            <v-autocomplete
                                label="Attributi"
                                :items="attributes"
                                v-model="attributesSelected"
                                multiple
                                autocomplete
                                small-chips
                                clearable
                                persistent-hint
                                return-object
                                item-text="label"
                                item-value="id"
                                dense
                                outlined
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                
                    <v-subheader v-if="attributesSelected.length > 0" class="pl-0">Valori Disponibili</v-subheader>

                    <template v-for="(input, i) in attributesSelected">
                        <v-row  v-if="input.type === 'list'" :key="i" class="ma-0">
                            <v-col>
                                <v-autocomplete
                                    :items="input.options"
                                    :label="input.label"
                                    v-model="attributesValue[input.id]"
                                    clearable
                                    multiple
                                    small-chips
                                    deletable-chips
                                    return-object
                                    item-text="text"
                                    item-value="value"
                                    dense
                                    outlined
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row v-else :key="i" class="ma-0">
                            <v-col>
                                <v-combobox
                                    :label="input.label"
                                    v-model="attributesValue[input.id]"
                                    color="primary"
                                    small-chips
                                    return-object
                                    item-text="text"
                                    item-value="value"
                                    multiple
                                    dense
                                    outlined
                                ></v-combobox>
                            </v-col>
                        </v-row>
                    </template>
                </v-container>
            </v-card>
        </v-col>
        <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
                <v-fab-transition>
                    <v-btn
                        v-on="{ ...tooltip }"
                        @click.native="updateModel()"
                        :loading="saved"
                        color="primary"
                        dark
                        fixed
                        bottom
                        right
                        fab>
                        <v-icon>sync</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <span>Aggiorna</span>
        </v-tooltip>
    </v-row>
</template>

<script>
export default {
    name: 'attributes-product',
    props: {
        id: Number,
        entityTitle: String
    },

    data() {
        return {
            saved: false,
            attributes: [],
            attributesSelected: [],
            attributesValue: {},
            model: [],
            modelDefs: 'products',
        }
    },

    created() {
        this.axios.get('products/' + this.id + '/attributes').then(response => {
            // get body data
            
            this.attributes = response.data.available_attributes

            let attrSelectedId = response.data.attributes.map((attrSelected) => {
                this.attributesValue[attrSelected.id] = attrSelected.values
                return attrSelected.id
            })
            this.attributesSelected = this.attributes.filter((attr) => {
                return attrSelectedId.includes(attr.id)
            })

            this.$store.commit('endProgress')

        }, response => {
                // error callback
        });
    },

    methods: {
        updateModel() {

            this.saved = true

            _.forEach(this.attributesSelected, (item, key) => {
                
                let attrSel = this.attributesSelected.filter((attr) => {
                    return attr.id === item.id
                })

                let validateAttributesValue = []

                if(attrSel[0]) {
                    if(attrSel[0].type == 'text') {
                        validateAttributesValue = this.attributesValue[item.id]
                    } else {
                        _.forEach((this.attributesValue[item.id]), (attr, key) => {
                            _.forEach(attrSel[0].options, (option, k) => {
                                if(attr.text === option.text && attr.value === option.value) {
                                    validateAttributesValue.push(attr)
                                }
                            })
                        })
                    }
                }

                this.model[key] = {
                    attribute_id: item.id,
                    product_id: this.id,
                    type: item.type,
                    values: validateAttributesValue
                }
                
            })

            this.axios.put('products/' + this.id + '/attributes', {'productattributes': this.model}).then(response => {
                // get body data
                this.model = []
                this.saved = false
                // Got in show
                this.$eventBusUtility.chooseRedirect(this.$router, response, this.redirect, this.modelDefs)
            }, response => {
                // error callback
            });

        },
    },
}
</script>

<style>

</style>
